export const jp = {
  jp: {

  }
}
